import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Madres y padres con hijos de 2 a 10 años que se sienten ignorados.', 'Madres que terminan el día agotadas y con culpa por haber gritado.', 'Familias que buscan una crianza respetuosa pero necesitan límites hoy.', 'Si sentís que perdiste el control de las rutinas (baño, sueño, comida).'];
  const notForWho = ['Quienes buscan obediencia ciega y sumisión absoluta.', 'Personas que no están dispuestas a dedicar 10 minutos al día a cambiar sus hábitos.', 'Quienes creen que el golpe o el miedo son la única forma de educar.'];
  return <section className="py-20 px-4 bg-[#FFF0E6]" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-3">
          {/* Para quién es */}
          <FadeIn data-id="element-4">
            <div className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-[#6B9E7A] h-full" data-id="element-5">
              <h3 className="font-serif text-2xl font-bold text-[#2D2A26] mb-6 flex items-center gap-3" data-id="element-6">
                <span className="bg-[#6B9E7A]/20 text-[#6B9E7A] p-2 rounded-full" data-id="element-7">
                  <CheckCircle2 className="w-6 h-6" data-id="element-8" />
                </span>
                Para quién ES esto
              </h3>
              <ul className="space-y-4" data-id="element-9">
                {forWho.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-10">
                    <CheckCircle2 className="w-5 h-5 text-[#6B9E7A] shrink-0 mt-1" data-id="element-11" />
                    <span className="font-sans text-[#2D2A26]/80 leading-relaxed" data-id="element-12">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Para quién NO es */}
          <FadeIn delay={200} data-id="element-13">
            <div className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-[#E8604C] h-full" data-id="element-14">
              <h3 className="font-serif text-2xl font-bold text-[#2D2A26] mb-6 flex items-center gap-3" data-id="element-15">
                <span className="bg-[#E8604C]/10 text-[#E8604C] p-2 rounded-full" data-id="element-16">
                  <XCircle className="w-6 h-6" data-id="element-17" />
                </span>
                Para quién NO es
              </h3>
              <ul className="space-y-4" data-id="element-18">
                {notForWho.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-19">
                    <XCircle className="w-5 h-5 text-[#E8604C] shrink-0 mt-1" data-id="element-20" />
                    <span className="font-sans text-[#2D2A26]/80 leading-relaxed" data-id="element-21">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}